import { AUTH_COOKIE } from '../modules/user'
import { AUTH_API_COOKIE, AUTH_API_PHOTO_COOKIE } from '../modules/user'
import jscookie from 'js-cookie'

const state = {
}

const mutations = {

/*	setBuildings (state, payload) {
		console.log(payload.find((bldg) => bldg.bldgAlpha == "101") ? "Using Secured Data" : "Not Using Secured Data")
		state.buildings = payload
	},*/
}

const actions = {

	confirmOccupancy ({commit, getters}, payload) {		
		const apiEsriToken = jscookie.get(AUTH_API_COOKIE)
		//console.log("Action: confirmOccupancy ")
		return new Promise((resolve, reject) => {
			fetch("https://api.ba.arizona.edu/if/occupant/updatelocations",
                        {
                            headers: {
                            'database' : getters.getDatabase(),
                            'Content-Type': 'application/json',
                            'apiEsriToken' : apiEsriToken, 'impersonate' : getters.impersonateID,
                            'impersonate' : getters.impersonateID,
                            },
                            method: "POST",
                            body: JSON.stringify(payload)
                    })
		      .then(response => response.json())
		      .then(data => {
		      	resolve(data)
		      })
		      .catch(e => {
		        console.log(e);
		        return 
		    })
		})
	},

	currentOccupancy ({commit, getters}, payload) {		
		const apiEsriToken = jscookie.get(AUTH_API_COOKIE)
		//console.log("Action: currentOccupancy ", payload)
		return new Promise((resolve, reject) => {
			fetch("https://api.ba.arizona.edu/if/occupant/locations",
                        {
                            headers: {
                            'database' : getters.getDatabase(),
                            'Content-Type': 'application/json',
                            'apiEsriToken' : apiEsriToken, 'impersonate' : getters.impersonateID,
                            },
                            method: "POST",
                            body: JSON.stringify(payload)
                    })
		      .then(response => response.json())
		      .then(data => {
		      	resolve(data)
		      })
		      .catch(e => {
		        console.log(e);
		        return 
		    })
		})
	},

	updateUserDept ({getters}, payload) {		
		const apiEsriToken = jscookie.get(AUTH_API_COOKIE)
		console.log("Action: updateUserDept ")
		//console.log(payload)
		return new Promise((resolve, reject) => {
			fetch("https://api.ba.arizona.edu/if/department/updateUserDept",
                        {
                            headers: {
                            'database' : getters.getDatabase(),
                            'Content-Type': 'application/json',
                            'apiEsriToken' : apiEsriToken, 'impersonate' : getters.impersonateID,
                            },
                            method: "POST",
                            body: JSON.stringify(payload)
                    })
		      .then(response => resolve(response.json()))
		      .then(data => {
		      })
		      .catch(e => {
		        console.log(e);
		        reject(e)
		        return 
		    })
		})
	},

	updateDepts ({getters}, payload) {		
		const apiEsriToken = jscookie.get(AUTH_API_COOKIE)
		console.log("Action: updateDepts ")
		//console.log(payload)
		return new Promise((resolve, reject) => {
			fetch("https://api.ba.arizona.edu/if/room/update/batch/department",
                        {
                            headers: {
                            'database' : getters.getDatabase(),
                            'Content-Type': 'application/json',
                            'apiEsriToken' : apiEsriToken, 'impersonate' : getters.impersonateID,
                            },
                            method: "POST",
                            body: JSON.stringify(payload)
                    })
		      .then(response => resolve(response.json()))
		      .then(data => {
		      })
		      .catch(e => {
		        console.log(e);
		        reject(e)
		        return 
		    })
		})
	},

	updateOccupant ({commit, getters}, payload) {		
		const apiEsriToken = jscookie.get(AUTH_API_COOKIE)
		console.log("Action: updateOccupant ")
			fetch("https://api.ba.arizona.edu/if/occupant/update/",
                        {
                            headers: {
                            'database' : getters.getDatabase(),
                            'Content-Type': 'application/json',
                            'apiEsriToken' : apiEsriToken, 'impersonate' : getters.impersonateID,
                            },
                            method: "POST",
                            body: JSON.stringify(payload)
                    })
		      .then(response => response.json())
		      .then(data => {
		      })
		      .catch(e => {
		        console.log(e);
		        return 
		    })
	},

	insertOccupant ({commit, getters}, payload) {
		const apiEsriToken = jscookie.get(AUTH_API_COOKIE)
		console.log("Action: insertOccupant ")
		return new Promise((resolve, reject) => {
			fetch("https://api.ba.arizona.edu/if/occupant/insert/",
                        {
                            headers: {
                            'database' : getters.getDatabase(),
                            'Content-Type': 'application/json',
                            'apiEsriToken' : apiEsriToken, 'impersonate' : getters.impersonateID,
                            },
                            method: "POST",
                            body: JSON.stringify(payload)
                    })
		      .then(response => resolve(response.json()))
		      .then(data => {
		      })
		      .catch(e => {
		        console.log(e);
		        return 
		    })
		})
	},

	deleteOccupant ({commit, getters}, payload) {
		const apiEsriToken = jscookie.get(AUTH_API_COOKIE)
		console.log("Action: deleteOccupant ")
		return new Promise((resolve, reject) => {
			fetch("https://api.ba.arizona.edu/if/occupant/delete/",
                        {
                            headers: {
                            'database' : getters.getDatabase(),
                            'Content-Type': 'application/json',
                            'apiEsriToken' : apiEsriToken, 'impersonate' : getters.impersonateID,
                            },
                            method: "POST",
                            body: JSON.stringify(payload)
                    })
		      .then(response => resolve(response.json()))
		      .then(data => {
		      })
		      .catch(e => {
		        console.log(e);
		        return 
		    })
		})
	},

	deleteOccupantFromAll ({commit, getters}, payload) {
		const apiEsriToken = jscookie.get(AUTH_API_COOKIE)
		console.log("Action: deleteOccupantFromAll ")
		return new Promise((resolve, reject) => {
			fetch("https://api.ba.arizona.edu/if/occupant/removeFromAll/",
                        {
                            headers: {
                            'database' : getters.getDatabase(),
                            'Content-Type': 'application/json',
                            'apiEsriToken' : apiEsriToken, 'impersonate' : getters.impersonateID,
                            },
                            method: "POST",
                            body: JSON.stringify(payload)
                    })
		      .then(response => resolve(response.json()))
		      .then(data => {
		      })
		      .catch(e => {
		        console.log(e);
		        return 
		    })
		})
	},

	insertPI ({commit, getters}, payload) {
		const apiEsriToken = jscookie.get(AUTH_API_COOKIE)
		console.log("Action: insertPI ")
		return new Promise((resolve, reject) => {
			fetch("https://api.ba.arizona.edu/if/pi/insert/",
                        {
                            headers: {
                            'database' : getters.getDatabase(),
                            'Content-Type': 'application/json',
                            'apiEsriToken' : apiEsriToken, 'impersonate' : getters.impersonateID,
                            },
                            method: "POST",
                            body: JSON.stringify(payload)
                    })
		      .then(response => resolve(response.json()))
		      .then(data => {
		      })
		      .catch(e => {
		        console.log(e);
		        return 
		    })
		})
	},

	deletePI ({commit, getters}, payload) {
		const apiEsriToken = jscookie.get(AUTH_API_COOKIE)
		console.log("Action: deletePI ")
		return new Promise((resolve, reject) => {
			fetch("https://api.ba.arizona.edu/if/pi/delete/",
                        {
                            headers: {
                            'database' : getters.getDatabase(),
                            'Content-Type': 'application/json',
                            'apiEsriToken' : apiEsriToken, 'impersonate' : getters.impersonateID,
                            },
                            method: "POST",
                            body: JSON.stringify(payload)
                    })
		      .then(response => resolve(response.json()))
		      .then(data => {
		      })
		      .catch(e => {
		        console.log(e);
		        return 
		    })
		})
	},

	//Delete a PI from an array of room keys
	deletePIFromSelected ({commit, getters}, payload) {
		const apiEsriToken = jscookie.get(AUTH_API_COOKIE)
		console.log("Action: deletePIFromSelected ")
		return new Promise((resolve, reject) => {
			fetch("https://api.ba.arizona.edu/if/pi/removeFromSelected/",
                        {
                            headers: {
                            'database' : getters.getDatabase(),
                            'Content-Type': 'application/json',
                            'apiEsriToken' : apiEsriToken, 'impersonate' : getters.impersonateID,
                            },
                            method: "POST",
                            body: JSON.stringify(payload)
                    })
		      .then(response => resolve(response.json()))
		      .then(data => {
		      })
		      .catch(e => {
		        console.log(e);
		        return 
		    })
		})
	},

	//Delete an Occupant from an array of room keys
	deleteOccupantFromSelected ({commit, getters}, payload) {
		const apiEsriToken = jscookie.get(AUTH_API_COOKIE)
		console.log("Action: deleteOccupantFromSelected ")
		return new Promise((resolve, reject) => {
			fetch("https://api.ba.arizona.edu/if/occupant/removeFromSelected/",
                        {
                            headers: {
                            'database' : getters.getDatabase(),
                            'Content-Type': 'application/json',
                            'apiEsriToken' : apiEsriToken, 'impersonate' : getters.impersonateID,
                            },
                            method: "POST",
                            body: JSON.stringify(payload)
                    })
		      .then(response => resolve(response.json()))
		      .then(data => {
		      })
		      .catch(e => {
		        console.log(e);
		        return 
		    })
		})
	},

	//NOT YET IMPLEMENTED
	deletePIFromAll ({commit, getters}, payload) {
		const apiEsriToken = jscookie.get(AUTH_API_COOKIE)
		console.log("Action: deletePIFromAll ")
		return new Promise((resolve, reject) => {
			fetch("https://api.ba.arizona.edu/if/pi/removeFromAll/",
                        {
                            headers: {
                            'database' : getters.getDatabase(),
                            'Content-Type': 'application/json',
                            'apiEsriToken' : apiEsriToken, 'impersonate' : getters.impersonateID,
                            },
                            method: "POST",
                            body: JSON.stringify(payload)
                    })
		      .then(response => resolve(response.json()))
		      .then(data => {
		      })
		      .catch(e => {
		        console.log(e);
		        return 
		    })
		})
	},

	insertRoomPercentage ({commit, getters}, payload) {
		const apiEsriToken = jscookie.get(AUTH_API_COOKIE)
		console.log("Action: insertRMPCT ")
		return new Promise((resolve, reject) => {
			fetch("https://api.ba.arizona.edu/if/RoomPercent/Insert/",
                        {
                            headers: {
                            'database' : getters.getDatabase(),
                            'Content-Type': 'application/json',
                            'apiEsriToken' : apiEsriToken, 'impersonate' : getters.impersonateID,
                            },
                            method: "POST",
                            body: JSON.stringify(payload)
                    })
		      .then(response => resolve(response.json()))
		      .catch(e => {
		        console.log(e);
		        return 
		    })
		})
	},

	updateRoomPercentage ({commit, getters}, payload) {
		const apiEsriToken = jscookie.get(AUTH_API_COOKIE)
		console.log("Action: modifyRMPCT ")
		return new Promise((resolve, reject) => {
			fetch("https://api.ba.arizona.edu/if/RoomPercent/Update/",
                        {
                            headers: {
                            'database' : getters.getDatabase(),
                            'Content-Type': 'application/json',
                            'apiEsriToken' : apiEsriToken, 'impersonate' : getters.impersonateID,
                            },
                            method: "POST",
                            body: JSON.stringify(payload)
                    })
		      .then(response => resolve(response.json()))
		      .then(data => {
		      })
		      .catch(e => {
		        console.log(e);
		        reject(e)
		        return 
		    })
		})
	},

	deleteRoomPercentage ({commit, getters}, payload) {
		const apiEsriToken = jscookie.get(AUTH_API_COOKIE)
		console.log("Action: deleteRMPCT ")
		return new Promise((resolve, reject) => {
			fetch("https://api.ba.arizona.edu/if/RoomPercent/Delete/",
                        {
                            headers: {
                            'database' : getters.getDatabase(),
                            'Content-Type': 'application/json',
                            'apiEsriToken' : apiEsriToken, 'impersonate' : getters.impersonateID,
                            },
                            method: "POST",
                            body: JSON.stringify(payload)
                    })
		      .then(response => resolve(response.json()))
		      .then(data => {
		      })
		      .catch(e => {
		        console.log(e);
		        reject(e)
		        return 
		    })
		})
	},

	deleteAllRooms ({commit, getters}, payload) {
		const apiEsriToken = jscookie.get(AUTH_API_PHOTO_COOKIE)
			console.log("Action: deleteAllRooms " + payload)
				return new Promise((resolve, reject) => {
					fetch('https://api.pdc.arizona.edu/rooms/deleteAll/', {      
				      headers: {
				            'database' : getters.getDatabase(),				            
				            'content-type': 'application/json',
				            'apiEsriToken' : apiEsriToken, 'impersonate' : getters.impersonateID,
				      		},
				  			method: "POST",
                            body: JSON.stringify(payload)
                        })
				      .then(response => response.json())
				      .then(data => {
				      	resolve(data)
				      })
			    })
	},

	deleteRooms ({commit, getters}, payload) {
		const apiEsriToken = jscookie.get(AUTH_API_COOKIE)
			console.log("Action: deleteRoom " + payload)
				return new Promise((resolve, reject) => {
					fetch('https://api.ba.arizona.edu/if/rooms/delete/', {      
				      headers: {
				            'database' : getters.getDatabase(),				            
				            'content-type': 'application/json',
				            'apiEsriToken' : apiEsriToken, 'impersonate' : getters.impersonateID,
				      		},
				  			method: "POST",
                            body: JSON.stringify(payload)
                        })
				      .then(response => resolve(response.json()))
				      
			    })
	},

	saveRoom ({commit, getters}, payload) {
		const apiEsriToken = jscookie.get(AUTH_API_COOKIE)
			console.log("Action: saveRoom " + payload)
				return new Promise((resolve, reject) => {
					fetch('https://api.ba.arizona.edu/if/room/update/', {      
				      headers: {
				            'database' : getters.getDatabase(),				            
				            'content-type': 'application/json',
				            'apiEsriToken' : apiEsriToken, 'impersonate' : getters.impersonateID,
				      		},
				  			method: "POST",
                            body: JSON.stringify(payload)
                        })
				      .then(response => { 	
				      		if (response.status == 200) {
						        response.json().then((text) => { 
						        	console.log("Text: ", text)	
							      	if (!text.includes("Not saved")) {
							      		// If successful, add the payload to the LOCAL buildingrooms to avoid refetches
							      		commit('addRoomToBuildingRooms', payload)
							      	}
							    resolve(text)
							    })	
						    } 
						    else { 
						    	if (response.status == 401)	{ resolve ("Unauthorized to save these changes.") 	}
						    	else 						{ resolve ("Error") 								}
						    }
				      })
			    })
	},

	saveRoomsMulti ({commit, getters}, payload) {
		const apiEsriToken = jscookie.get(AUTH_API_COOKIE)
			console.log("Action: saveRoomsMulti " + payload)
				return new Promise((resolve, reject) => {
					fetch('https://api.ba.arizona.edu/if/room/update/batch', {      
				      headers: {
				            'database' : getters.getDatabase(),				            
				            'content-type': 'application/json',
				            'apiEsriToken' : apiEsriToken, 'impersonate' : getters.impersonateID,
				      		},
				  			method: "POST",
                            body: JSON.stringify(payload)
                        })
				      .then(response => resolve(response.json()))
				      .catch(e => {
				        console.log(e);
				        reject(e)
				        return e
				      })
			    })
	},

	updateProgram ({commit, getters}, payload) {
		const apiEsriToken = jscookie.get(AUTH_API_COOKIE)
		console.log("Action: updateProgram ")
		return new Promise((resolve, reject) => {
			fetch("https://api.ba.arizona.edu/if/Program/Insert/Batch",
                        {
                            headers: {
                            'database' : getters.getDatabase(),
                            'Content-Type': 'application/json',
                            'apiEsriToken' : apiEsriToken, 'impersonate' : getters.impersonateID,
                            },
                            method: "POST",
                            body: JSON.stringify(payload)
                    })
		      .then(response => resolve(response.json()))
		      .then(data => {
		      })
		      .catch(e => {
		        console.log(e);
		        reject(e)
		        return 
		    })
		})
	},

	insertAccount ({commit, getters}, payload) {
		const apiEsriToken = jscookie.get(AUTH_API_COOKIE)
		console.log("Action: insertAccount ")
			fetch("https://api.ba.arizona.edu/if/account/insert/",
                        {
                            headers: {
                            'database' : getters.getDatabase(),
                            'Content-Type': 'application/json',
                            'apiEsriToken' : apiEsriToken, 'impersonate' : getters.impersonateID,
                            },
                            method: "POST",
                            body: JSON.stringify(payload)
                    })
		      .then(response => response.json())
		      .then(data => {
		      })
		      .catch(e => {
		        console.log(e);
		        return 
		    })
	},

	deleteAccount ({commit, getters}, payload) {
		const apiEsriToken = jscookie.get(AUTH_API_COOKIE)
		console.log("Action: deleteAccount ")
			fetch("https://api.ba.arizona.edu/if/account/delete/",
                        {
                            headers: {
                            'database' : getters.getDatabase(),
                            'Content-Type': 'application/json',
                            'apiEsriToken' : apiEsriToken, 'impersonate' : getters.impersonateID,
                            },
                            method: "POST",
                            body: JSON.stringify(payload)
                    })
		      .then(response => response.json())
		      .then(data => {
		      })
		      .catch(e => {
		        console.log(e);
		        return 
		    })
	},

	uploadPhoto ({commit, getters}, payload) {
	const apiEsriToken = jscookie.get(AUTH_API_PHOTO_COOKIE)
	return new Promise((resolve, reject) => {
		console.log("Upload: ", payload)
		fetch("https://api.pdc.arizona.edu/room/uploadimage" ,
          {
            headers: {
                            'database' : getters.getDatabase(),
                            'Content-Type': 'application/json',
                            'apiEsriToken' : apiEsriToken, 'impersonate' : getters.impersonateID,
                            },
            method: "POST",
            body: JSON.stringify(payload)
          })
			.then(data => { resolve()
		    })
		})
	},

	deletePhoto ({commit, getters}, payload) {
	console.log("Action: deletePhoto")
	const apiEsriToken = jscookie.get(AUTH_API_PHOTO_COOKIE)
	return new Promise((resolve, reject) => {
		fetch("https://api.pdc.arizona.edu/room/deleteimage" ,
          {
            headers: {
                            'database' : getters.getDatabase(),
                            'Content-Type': 'application/json',
                            'apiEsriToken' : apiEsriToken, 'impersonate' : getters.impersonateID,
                            //'impersonate' : '06102720' // Walter Ries
                            },
            method: "POST",
            body: JSON.stringify({key: payload})
          })
			.then(response => response.json())
		      .then(data => { resolve()
		      })
		})
	},

	deletePhotos ({commit, getters}, payload) {
	const apiEsriToken = jscookie.get(AUTH_API_PHOTO_COOKIE)
	return new Promise((resolve, reject) => {
		fetch("https://api.pdc.arizona.edu/photos/delete" ,
          {
            headers: {
                            'database' : getters.	getDatabase(),
                            'Content-Type': 'application/json',
                            'apiEsriToken' : apiEsriToken, 'impersonate' : getters.impersonateID,
                            },
            method: "POST",
            body: JSON.stringify(payload)
          })
			.then(response => response.json())
		      .then(data => { resolve()
		      })
		})
	},

	updatePhotos ({commit, getters}, payload) {
	const apiEsriToken = jscookie.get(AUTH_API_COOKIE)
	return new Promise((resolve, reject) => {
		fetch("https://api.ba.arizona.edu/if/photos/update" ,
          {
            headers: {
                            'database' : getters.getDatabase(),
                            'Content-Type': 'application/json',
                            'apiEsriToken' : apiEsriToken, 'impersonate' : getters.impersonateID,
                            },
            method: "POST",
            body: JSON.stringify(payload)
          })
			.then(response => response.json())
		      .then(data => { resolve()
		      })
		})
	},

	updatePhotoRestrict ({commit, getters}, payload) {
	const apiEsriToken = jscookie.get(AUTH_API_COOKIE)
	return new Promise((resolve, reject) => {
		fetch("https://api.ba.arizona.edu/if/rooms/photoRestrict" ,
          {
            headers: {
                            'database' : getters.getDatabase(),
                            'Content-Type': 'application/json',
                            'apiEsriToken' : apiEsriToken, 'impersonate' : getters.impersonateID,
                            },
            method: "POST",
            body: JSON.stringify(payload)
          })
			.then(response => response.json())
		      .then(data => { resolve()
		      })
		})
	},

	bulkAssign ({commit, getters}, payload) {
	const apiEsriToken = jscookie.get(AUTH_API_COOKIE)
	return new Promise((resolve, reject) => {
		fetch("https://api.ba.arizona.edu/if/room/update/batch/assigndept" ,
          {
            headers: {
                            'database' : getters.getDatabase(),
                            'Content-Type': 'application/json',
                            'apiEsriToken' : apiEsriToken, 'impersonate' : getters.impersonateID,
                            },
            method: "POST",
            body: JSON.stringify(payload)
          })
			.then(response => resolve(response.json()) )
		})
	},

	bulkProgram ({commit, getters}, payload) {
	const apiEsriToken = jscookie.get(AUTH_API_COOKIE)
	return new Promise((resolve, reject) => {
		fetch("https://api.ba.arizona.edu/if/room/update/batch/program" ,
          {
            headers: {
                            'database' : getters.getDatabase(),
                            'Content-Type': 'application/json',
                            'apiEsriToken' : apiEsriToken, 'impersonate' : getters.impersonateID,
                            },
            method: "POST",
            body: JSON.stringify(payload)
          })
			.then(response => resolve(response.json()))
		})
	},

	bulkReplaceAccounts ({commit, getters}, payload) {
	const apiEsriToken = jscookie.get(AUTH_API_COOKIE)
	return new Promise((resolve, reject) => {
		fetch("https://api.ba.arizona.edu/if/room/update/batch/accounts" ,
          {
            headers: {
                            'database' : getters.getDatabase(),
                            'Content-Type': 'application/json',
                            'apiEsriToken' : apiEsriToken, 'impersonate' : getters.impersonateID,
                            },
            method: "POST",
            body: JSON.stringify(payload)
          })
			.then(response => resolve(response.json()))
		})
	},

	bulkDeleteOccupants ({commit, getters}, payload) {
	const apiEsriToken = jscookie.get(AUTH_API_COOKIE)
	return new Promise((resolve, reject) => {
		fetch("https://api.ba.arizona.edu/if/room/delete/batch/occupant" ,
          {
            headers: {
                            'database' : getters.getDatabase(),
                            'Content-Type': 'application/json',
                            'apiEsriToken' : apiEsriToken, 'impersonate' : getters.impersonateID,
                            },
            method: "POST",
            body: JSON.stringify(payload)
          })
			.then(response => resolve(response.json()))
		})
	},

	bulkDeletePIs ({commit, getters}, payload) {
	const apiEsriToken = jscookie.get(AUTH_API_COOKIE)
	return new Promise((resolve, reject) => {
		fetch("https://api.ba.arizona.edu/if/room/delete/batch/pi" ,
          {
            headers: {
                            'database' : getters.getDatabase(),
                            'Content-Type': 'application/json',
                            'apiEsriToken' : apiEsriToken, 'impersonate' : getters.impersonateID,
                            },
            method: "POST",
            body: JSON.stringify(payload)
          })
			.then(response => resolve(response.json()))
		})
	},

	bulkAddOccupant ({commit, getters}, payload) {
	const apiEsriToken = jscookie.get(AUTH_API_COOKIE)
	return new Promise((resolve, reject) => {
		fetch("https://api.ba.arizona.edu/if/room/add/batch/occupant" ,
          {
            headers: {
                            'database' : getters.getDatabase(),
                            'Content-Type': 'application/json',
                            'apiEsriToken' : apiEsriToken, 'impersonate' : getters.impersonateID,
                            },
            method: "POST",
            body: JSON.stringify(payload)
          })
			.then(response => resolve(response.json()))
		})
	},

	bulkAddPI ({commit, getters}, payload) {
	const apiEsriToken = jscookie.get(AUTH_API_COOKIE)
	return new Promise((resolve, reject) => {
		fetch("https://api.ba.arizona.edu/if/room/add/batch/pi" ,
          {
            headers: {
                            'database' : getters.getDatabase(),
                            'Content-Type': 'application/json',
                            'apiEsriToken' : apiEsriToken, 'impersonate' : getters.impersonateID,
                            },
            method: "POST",
            body: JSON.stringify(payload)
          })
			.then(response => resolve(response.json()))
		})
	},

	saveBuilding ({commit, getters}, payload) {
	const apiEsriToken = jscookie.get(AUTH_API_COOKIE)
	return new Promise((resolve, reject) => {
		fetch("https://api.ba.arizona.edu/if/building/update" ,
          {
            headers: {
                            'database' : getters.getDatabase(),
                            'Content-Type': 'application/json',
                            'apiEsriToken' : apiEsriToken, 'impersonate' : getters.impersonateID,
                            },
            method: "POST",
            body: JSON.stringify(payload)
          })
			.then(response => resolve(response.json()))
		})
	},

	saveFloor ({commit, getters}, payload) {
	const apiEsriToken = jscookie.get(AUTH_API_COOKIE)
	return new Promise((resolve, reject) => {
		fetch("https://api.ba.arizona.edu/if/floor/update" ,
          {
            headers: {
                            'database' : getters.getDatabase(),
                            'Content-Type': 'application/json',
                            'apiEsriToken' : apiEsriToken, 'impersonate' : getters.impersonateID,
                            },
            method: "POST",
            body: JSON.stringify(payload)
          })
			.then(response => response.json())
		      .then(data => { resolve(data)
		      })
		})
	},

	deleteFloor ({commit, getters}, payload) {
	const apiEsriToken = jscookie.get(AUTH_API_COOKIE)
	return new Promise((resolve, reject) => {
		fetch("https://api.ba.arizona.edu/if/floor/delete" ,
          {
            headers: {
                            'database' : getters.getDatabase(),
                            'Content-Type': 'application/json',
                            'apiEsriToken' : apiEsriToken, 'impersonate' : getters.impersonateID,
                            },
            method: "POST",
            body: JSON.stringify(payload)
          })
			.then(response => response.json())
		      .then(data => { resolve(data)
		      })
		})
	},


}
export default {
  //state,
  //getters,
  actions,
  //mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/space-edit.js